import Immutable, { List } from 'immutable';
import {
  ProjectDriveFile,
  RawProjectDriveFile,
} from 'records/ProjectDriveFile';
import {
  ProjectDriveFolderDetails,
  RawProjectDriveFolderDetails,
} from 'records/ProjectDriveFolderDetails';

export interface RawProjectDriveFolderItems {
  id: string;
  count: number;
  folders: RawProjectDriveFolderDetails[];
  documents: RawProjectDriveFile[];
}

export interface ProjectDriveFolderItemsData {
  id: string;
  count: number;
  folders: Immutable.List<ProjectDriveFolderDetails>;
  documents: Immutable.List<ProjectDriveFile>;
}

const defaultValues: ProjectDriveFolderItemsData = {
  id: '',
  count: 0,
  folders: Immutable.List<ProjectDriveFolderDetails>(),
  documents: Immutable.List<ProjectDriveFile>(),
};

export const ProjectDriveFolderItemsFactory = Immutable.Record(
  defaultValues,
  'ProjectDriveFolderItems'
);

export class ProjectDriveFolderItems extends ProjectDriveFolderItemsFactory {
  static deserialize(
    rawProjectDriveFolderItems: RawProjectDriveFolderItems
  ): ProjectDriveFolderItems {
    const { id, count, folders, documents } = rawProjectDriveFolderItems;

    return new ProjectDriveFolderItems({
      id,
      count,
      folders: List(folders.map(ProjectDriveFolderDetails.deserialize)),
      documents: List(documents.map(ProjectDriveFile.deserialize)),
    });
  }

  serialize(): RawProjectDriveFolderItems {
    return this.toJS();
  }
}
